import {Outlet} from 'react-router-dom'
import {ContentArea} from '@/components/shared/ContentArea'
import {useAuth} from '@/contexts/auth-context'
import {usePageTitle} from '@/hooks/use-page-title'
import {useI18n} from '@/i18n'
import {InlineRow} from '@/components/shared/InlineRow'
import {SidebarNav, type SidebarNavItem} from '@/components/layout/SidebarNav'
import {SidebarNavId} from '@/testids/SidebarNavTestIds'
import {routes} from '@/lib/routes'
import {permissions} from '@/lib/permissions'
import {CONCEPT_ICON} from '@/lib/concepts'
import {SectionContainer} from '@/components/shared/SectionContainer'


export function Analytics() {
    const i18n = useI18n()
    usePageTitle(i18n.analytics.pageTitle)
    const {hasPermission} = useAuth()

    const menuItems: (SidebarNavItem & { permission: string })[] = [
        {
            id: SidebarNavId.EffectiveAccessDashboard,
            title: i18n.analytics.dashboard as string,
            href: routes.effectiveAccess.dashboard.path(),
            icon: CONCEPT_ICON.analyticsDashboard,
            description: i18n.analytics.dashboardDesc as string,
            permission: permissions.identities.view,
        },
        {
            id: SidebarNavId.EffectiveAccessIdentities,
            title: i18n.analytics.byIdentity as string,
            href: routes.effectiveAccess.identities.list(),
            icon: CONCEPT_ICON.identity,
            description: i18n.analytics.byIdentityDesc as string,
            permission: permissions.identities.view,
        },
        {
            id: SidebarNavId.EffectiveAccessSystems,
            title: i18n.analytics.bySystem as string,
            href: routes.effectiveAccess.systems.list(),
            icon: CONCEPT_ICON.system,
            description: i18n.analytics.bySystemDesc as string,
            permission: permissions.systems.view,
        },
        {
            id: SidebarNavId.Compare,
            title: i18n.analytics.compare as string,
            href: routes.effectiveAccess.compare.path(),
            icon: CONCEPT_ICON.compareGrants,
            description: i18n.analytics.compareDesc as string,
            permission: permissions.identities.view,
        },
    ]

    const visibleMenuItems = menuItems.filter(item => hasPermission(item.permission))

    return (
        <SectionContainer>
            <InlineRow align="start">
                <SidebarNav items={visibleMenuItems} aria-label={String(i18n.analytics.pageTitle)}/>

                {/* Content Area */}
                <ContentArea>
                    <Outlet/>
                </ContentArea>
            </InlineRow>
        </SectionContainer>
    )
}
